import { Navigate, Route, Routes as Switch } from 'react-router-dom';

import { getAccountRoutes } from 'modules/account';
import { DashboardRoutesConfig, getDashboardRoutes } from 'modules/dashboard';
import { useTranslation } from 'modules/i18n';
import { getTaskRoutes } from 'modules/task';

import { RootRoute } from './RootRoute';
import translation from './routes.translation';

export function Routes(): JSX.Element {
  const { t, keys } = useTranslation(translation);

  return (
    <Switch>
      <Route path="/" element={<RootRoute />}>
        <Route
          path="/"
          element={
            <Navigate
              to={DashboardRoutesConfig.dashboard.generatePath()}
              replace
            />
          }
        />

        {getDashboardRoutes()}

        {getTaskRoutes()}

        {getAccountRoutes()}

        <Route>{t(keys.pageNotFound)}</Route>
      </Route>
    </Switch>
  );
}
